// we can't be sure that crypto is available so this helps with dynamic key generation
export function generateUniqueKey(): string {
  // Generate a timestamp to ensure uniqueness
  const timestamp = Date.now()

  // Generate a random number (can be improved for better randomness)
  const randomPart = Math.random().toString(36).substring(2, 15)

  // Combine the timestamp and random part to create a unique key
  const uniqueKey = `${timestamp}-${randomPart}`

  return uniqueKey
}
